module.exports = __webpack_public_path__ + "static/media/haiviz_sampleDataset.61405adf.zip";


//////////////////
// WEBPACK FOOTER
// ./src/files/haiviz_sampleDataset.zip
// module id = 836
// module chunks = 0